export default {"src":"/_next/static/image/public/images/ic_video_pdp.e1b4c4a9a4b4b040ee20c57f31994bab.svg","height":64,"width":64};